



































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getServerList } from "@/req/game";
import showDownload from "./gameCom/showDownload.vue";
@Component({
  components: { showDownload },
})
export default class Home extends Vue {
  @Prop({ type: String, default: "" })
  public url;
  //   public url = "http://list.dhsf.yjy-game.com/box_serverlist/288.txt";
  public data: any = [];
  public selectTree = "";
  public bottomHeight = 0;
  public mounted() {
    window.addEventListener("scroll", this.add);
    this.getList();
  }
  public add() {
    const htop =
      document.documentElement.scrollHeight -
      document.documentElement.scrollTop -
      document.documentElement.clientHeight;
    if (htop < 237) {
      this.bottomHeight = 237 - htop;
    } else {
      this.bottomHeight = 0;
    }
  }
  public destroyed() {
    window.removeEventListener("scroll", this.add);
  }
  @Watch("url")
  public changeUrl() {
    this.getList();
  }
  public async getList() {
    if (this.url == "") {
      return false;
    }
    this.data = [];
    this.$emit("sendServer", { serverid: "", list_name: "" });
    const res = await getServerList(this.url);
    for (const key in res) {
      if (Object.prototype.hasOwnProperty.call(res, key)) {
        const element = res[key];
        element.expand = true;
        this.data.push(element);
      }
    }
  }
  public changeExpand(i) {
    this.data[i].expand = !this.data[i].expand;
  }
  public selectServer(item) {
    this.selectTree = item.id;
  }
  public async showDownload() {
    const res = await this.$fn.getGameLinks();
    this.showDownloads(res.pc_down_url);
  }
  public showDownloads(url) {
    window.location.href = url;
  }
}
